// extracted by mini-css-extract-plugin
export var breadcrumb = "_1i-0";
export var breadcrumbArrow = "_1i-1";